import React, { useState } from 'react';
import cx from 'classnames';
import { isStore } from '../../utils/functions';
import { Icon } from '../Icons';
import styles from './CallNow.module.css';
import { ContainerCallNow } from './components/ContainerCallNow';
import { PhoneCallNow } from './components/PhoneCallNow';

interface Props {
  hasToCall: boolean;
  numberPhone: string;
  name?: string;
  type: 'big' | 'small';
  dataValue?: string | any;
  contacts?: { infoContact: string }[];
  adId: number;
}

export const CallNow = ({ hasToCall, numberPhone, type, dataValue, contacts, adId }: Props) => {
  const icon = hasToCall ? 'SvgIconShowPhone' : 'SvgIconShowWhatsapp';
  const [seeNumber, setSeeNumber] = useState(false);
  const store = isStore() ? '' : 'Ad';
  const isPhone = hasToCall ? 'CallToStore' : `SendMessageWpp${store}`;
  const toggleDataValueClass = seeNumber ? `gtm${isPhone}` : `gtmShow${isPhone}`;

  const onClick = () => {
    setSeeNumber(!seeNumber);
  };
  const iconProps =
    type === 'big'
      ? {
          width: 48,
          height: 48,
          className: toggleDataValueClass,
        }
      : {
          width: 30,
          height: 29,
          className: cx('ml16 ml12-l', styles.icon, toggleDataValueClass),
        };

  const containerClass = cx('flex self-center', toggleDataValueClass, {
    mr4: type === 'small',
  });

  const handleMapContacts = () => {
    if (seeNumber) {
      return (
        <div className="mb8 mr8">
          <Icon name={icon} {...iconProps} customId={type} dataValue={dataValue} />
        </div>
      );
    }
  };

  const renderIcons = () => {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignContent: 'space-between' }}>
        <div className="mb8 mr8">
          <Icon name={icon} {...iconProps} customId={type} dataValue={dataValue} />
        </div>

        {contacts?.map(handleMapContacts)}
      </div>
    );
  };

  return (
    <ContainerCallNow
      hasToCall={hasToCall}
      onClick={onClick}
      seeNumber={seeNumber}
      type={type}
      dataValue={dataValue}
      dataValueClassName={toggleDataValueClass}
    >
      {renderIcons()}

      <div data-value={dataValue} className={containerClass}>
        <PhoneCallNow
          numberPhone={numberPhone}
          seeNumber={seeNumber}
          hasToCall={hasToCall}
          type={type}
          dataValue={dataValue}
          dataValueClassName={toggleDataValueClass}
          contacts={contacts}
          adId={adId}
        />
      </div>
    </ContainerCallNow>
  );
};
